import React, { useContext } from 'react';
import Alert from 'js/components/alert/alert';
import Box from 'js/components/box/box';
import Button from 'js/components/button/button';
import Spinner from 'js/components/spinner/spinner';
import Text from 'js/components/text/text';
import NoMatchedAppsNotice from './no-matched-apps-notice';
import MatchedAppItem from './matched-app-item';
import ContextDetailContext from '../../../contexts/context-detail.context';

export default function MatchedApps() {
    const {
        context: {
            current: context,
            current: { rules },
        },
        channels,
        matchedApps: {
            list: matchedApps,
            load: getMatchedApps,
            loadingAppMatches: loading,
            appMatchError: loadingError,
            needsReload,
        },
    } = useContext(ContextDetailContext);

    const hasActiveDimensions = rules.filter(
        (item) => item.keywords.length || item.topics.length,
    ).length;

    if (loading) {
        return (
            <Spinner
                size="large"
                message="Loading"
                color={['gray', 'dark']}
                isCentered
            />
        );
    }

    if (loadingError) {
        return (
            <Alert
                theme="danger"
                title="There Was An Unexpected Error Loading Matching Apps"
                actionItems={
                    <Button onClick={getMatchedApps}>Retry Loading Apps</Button>
                }
            >
                <p>
                    Hopefully it is only a temporary issue. Please try loading
                    the matching apps again in a few moments.
                </p>
            </Alert>
        );
    }

    // No Active Dimensions
    if (!hasActiveDimensions && !needsReload)
        return (
            <Alert theme="empty" title="No Active Dimensions">
                <Text color={['gray', 'dark']}>
                    <Box margin={[0, 0, 'small']}>
                        <p>
                            When a dimension has been activated you will be able
                            to view matched apps here.
                        </p>
                    </Box>
                </Text>
            </Alert>
        );

    if (!matchedApps.length)
        return <NoMatchedAppsNotice context={context} channels={channels} />;

    return (
        <Box margin={[0, 0, '-base', 0]}>
            {matchedApps.map((item) => (
                <Box margin={[0, 0, 'base']} key={item.url}>
                    <MatchedAppItem matchedApp={item} />
                </Box>
            ))}
        </Box>
    );
}
